import { createSelector } from 'reselect';

export const selectActiveUser = createSelector(
  [(state, activeUserId) => state.users.users, (state, activeUserId) => activeUserId],
  (users, id) => {
    if (users.get('loaded') && id) {
      const activeUser = users.getIn(['data', 'results']).find(user => user.get('id') === id);

      return activeUser ? activeUser.toJS() : null;
    }
    return null;
  }
);



// WEBPACK FOOTER //
// ./src/users/selectors.js